export default __webpack_public_path__ + "static/media/cover.8ea3c275.jpg";